import { Component, Input, OnInit } from '@angular/core';
import { Msisdn } from 'app/shared/msisdn/msisdns';

@Component({
  selector: 'cc-msisdn-dropdown-item',
  templateUrl: './msisdn-dropdown-item.component.html',
  styleUrls: ['./msisdn-dropdown-item.component.scss']
})
export class MsisdnDropdownItemComponent implements OnInit {
  @Input() msisdn: Msisdn;

  constructor() {}

  ngOnInit() {}
}
